module.exports = __webpack_public_path__ + "static/media/SmartShop_5-286w.cc1362ce.png";